import { AppLayout } from '@cloudscape-design/components';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import GlobalHelpPanel from '../../../components/GlobalHelpPanel';
import GlobalNavigationPanel from '../../../components/GlobalNavigationPanel';
import { selectIsNavigationPanelOpen, setNavigationPanelOpen } from '../../../slices/SitePreferencesSlice';
import { AppDispatch } from '../../../store/store';
import BlocksHomePageContent from './components/BlocksHomePageContent';

export default function BlocksHomePage() {
  const dispatch = useDispatch<AppDispatch>();
  const isNavigationPanelOpen = useSelector(selectIsNavigationPanelOpen);

  const navigationChangeHandler = () => {
    dispatch(setNavigationPanelOpen(!isNavigationPanelOpen));
  };

  return (
    <AppLayout
      headerSelector="#tw-header"
      content={<BlocksHomePageContent />}
      navigation={<GlobalNavigationPanel />}
      navigationOpen={isNavigationPanelOpen}
      onNavigationChange={navigationChangeHandler}
      tools={<GlobalHelpPanel />}
      disableContentPaddings={true}
    />
  );
}
